import { LayoutState, TabState } from './pane.types';
import type { WorkspaceId, LayoutStyleId, DatasetId, PaneId, TabId } from './id.types';

// ワークスペース作成コンテキスト
export interface WorkspaceCreationContext {
  datasetId?: DatasetId;
  datasetName?: string;
  predictedColumn?: string;
  residualColumn?: string;
  regressionConfig?: {
    xColumns: string[];
    yColumn: string;
    includeIntercept: boolean;
  };
  [key: string]: unknown;  // 拡張可能
}

// タブ作成設定
export interface TabCreationConfig {
  paneId: PaneId;
  tab: Omit<TabState, 'id'> & { id?: TabId };
}

// 自動タブ配置設定
export interface AutoTabsConfig {
  requiresContext?: boolean;  // コンテキストが必要か
  createTabs: (context: WorkspaceCreationContext) => TabCreationConfig[];
}

// レイアウトスタイル（テンプレート）
export interface LayoutStyle {
  id: LayoutStyleId;
  name: string;
  description?: string;
  layoutState: LayoutState;  // レイアウトのテンプレート
  isBuiltin?: boolean;  // ビルトインスタイル（削除不可）
  autoTabsConfig?: AutoTabsConfig;  // タブ自動配置設定
}

// ワークスペース
export interface Workspace {
  id: WorkspaceId;
  name: string;
  layoutState: LayoutState;  // 実際のレイアウト状態
  createdFromStyleId?: LayoutStyleId;  // 作成元のスタイルID（参考情報）
  creationContext?: WorkspaceCreationContext;  // ワークスペース作成時のコンテキスト
}

// ビルトインスタイルのID
export enum BuiltinLayoutStyleId {
  DEFAULT = 'builtin-default',
  THREE_PANE_ANALYSIS = 'builtin-three-pane-analysis',
  HORIZONTAL_SPLIT = 'builtin-horizontal-split',
  VERTICAL_SPLIT = 'builtin-vertical-split',
  RESIDUAL_ANALYSIS = 'builtin-residual-analysis',
}

// ワークスペース作成オプション
export interface CreateWorkspaceOptions {
  name: string;
  styleId?: LayoutStyleId;
  layoutState?: LayoutState;
  creationContext?: WorkspaceCreationContext;  // 作成時のコンテキスト情報
}